import React from 'react';

const ChunkLoadErrorDesktopRefreshIcon = () => {
  return (
    (<svg
      width="385"
      height="300"
      viewBox="0 0 628 389"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="ChunkLoadErrorDesktopRefreshIcon">
      <g filter="url(#filter0_f_2_171)">
        <ellipse cx="314.298" cy="341.667" rx="269.345" ry="2.97619" fill="black" />
      </g>
      <path
        d="M73.3333 28C73.3333 13.0883 85.4216 1 100.333 1H530.048C544.959 1 557.048 13.0883 557.048 28V325.762C557.048 327.419 555.704 328.762 554.048 328.762H76.3333C74.6765 328.762 73.3333 327.419 73.3333 325.762V28Z"
        fill="#1A202C"
        stroke="#4A5568"
        strokeWidth="2"
      />
      <path
        d="M75.3095 24.9762C75.3095 12.8259 85.1593 2.9762 97.3095 2.9762H533.071C545.222 2.9762 555.071 12.8259 555.071 24.9762V317.262H75.3095V24.9762Z"
        fill="black"
      />
      <rect x="87.7143" y="19.7143" width="452.976" height="284.524" fill="#191A1F" />
      <path
        d="M14 329.381C14 328.276 14.8954 327.381 16 327.381H612C613.105 327.381 614 328.276 614 329.381V330.952H14V329.381Z"
        fill="#A3ACB1"
      />
      <path
        d="M14 329.381C14 328.276 14.8954 327.381 16 327.381H612C613.105 327.381 614 328.276 614 329.381V330.952H14V329.381Z"
        fill="url(#paint0_linear_2_171)"
      />
      <path
        d="M14 330.952H614C590.447 335.702 566.48 338.095 542.454 338.095H79.0698C57.1842 338.095 35.3644 335.7 14 330.952Z"
        fill="#647279"
      />
      <path
        d="M14 330.952H614C590.447 335.702 566.48 338.095 542.454 338.095H79.0698C57.1842 338.095 35.3644 335.7 14 330.952Z"
        fill="url(#paint1_linear_2_171)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.972 327.381C270.278 329.375 268.793 330.952 273.524 330.952H355.071C359.802 330.952 358.317 329.375 358.623 327.381H269.972Z"
        fill="#96A1A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.972 327.381C270.278 329.375 268.793 330.952 273.524 330.952H355.071C359.802 330.952 358.317 329.375 358.623 327.381H269.972Z"
        fill="url(#paint2_linear_2_171)"
      />
      <path
        d="M291.587 136.056C297.809 130.665 305.768 127.703 314 127.714C332.936 127.714 348.286 143.064 348.286 162C348.286 169.323 345.989 176.112 342.08 181.68L331.143 162H341.429C341.429 156.623 339.849 151.364 336.885 146.877C333.92 142.391 329.703 138.875 324.756 136.766C319.809 134.657 314.352 134.049 309.063 135.017C303.773 135.985 298.885 138.487 295.006 142.21L291.587 136.056ZM336.413 187.944C330.191 193.335 322.232 196.297 314 196.286C295.064 196.286 279.714 180.936 279.714 162C279.714 154.677 282.011 147.888 285.92 142.32L296.857 162H286.571C286.571 167.377 288.151 172.636 291.115 177.123C294.08 181.609 298.297 185.125 303.244 187.234C308.191 189.343 313.648 189.951 318.937 188.983C324.227 188.015 329.115 185.513 332.994 181.79L336.413 187.944Z"
        fill="#00BD84"
      />
      <defs>
        <filter
          id="filter0_f_2_171"
          x="0.952362"
          y="294.69"
          width="626.69"
          height="93.9524"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="22" result="effect1_foregroundBlur_2_171" />
        </filter>
        <linearGradient
          id="paint0_linear_2_171"
          x1="14"
          y1="329.167"
          x2="614"
          y2="329.167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1012" />
          <stop offset="0.0295345" stopColor="#CAD4DB" />
          <stop offset="0.0625" stopColor="#242729" />
          <stop offset="0.133609" stopColor="#A3ACB1" />
          <stop offset="0.865967" stopColor="#A3ACB1" />
          <stop offset="0.941937" stopColor="#242729" />
          <stop offset="0.971275" stopColor="#CAD4DB" />
          <stop offset="0.996436" stopColor="#0D1012" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_171"
          x1="314"
          y1="330.952"
          x2="314"
          y2="338.095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A7F83" />
          <stop offset="1" stopColor="#0B0B0E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_171"
          x1="274.417"
          y1="329.549"
          x2="355.964"
          y2="329.549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C3C3C" />
          <stop offset="0.317518" stopColor="#3C3C3C" stopOpacity="0" />
          <stop offset="0.660584" stopColor="#3C3C3C" stopOpacity="0" />
          <stop offset="1" stopColor="#444444" />
        </linearGradient>
      </defs>
    </svg>)
  );
};

export default ChunkLoadErrorDesktopRefreshIcon;
